// extracted by mini-css-extract-plugin
module.exports = {"GetToKnow":"GetToKnowBlock_GetToKnow__3upYW","GetToKnowWrap":"GetToKnowBlock_GetToKnowWrap__cYTZY"};